import "react-toastify/dist/ReactToastify.css";
import { Flip, toast } from "react-toastify";
import { debounce } from "lodash";

let debouncedSuccessNotify = null;
let debouncedErrorNotify = null;
let debouncedWarningNotify = null;
let debouncedInfoNotify = null;


export const successNotify = (message) => {
  if (!debouncedSuccessNotify) {
    toast.success(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      transition: Flip,
      theme: "colored",
    });
    debouncedSuccessNotify = debounce(() => {
      debouncedSuccessNotify = null;
    }, 2000);
    debouncedSuccessNotify();
  } else {
    debouncedSuccessNotify();
  }
};

export const errorNotify = (message) => {
  if (!debouncedErrorNotify) {
    toast.error(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      transition: Flip,
      theme: "colored",
    });
    debouncedErrorNotify = debounce(() => {
      debouncedErrorNotify = null;
    }, 2000);
    debouncedErrorNotify();
  } else {
    debouncedErrorNotify();
  }
};

export const warningNotify = (message) => {
  if (!debouncedWarningNotify) {
    toast.warning(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      transition: Flip,
      theme: "colored",
    });
    debouncedWarningNotify = debounce(() => {
      debouncedWarningNotify = null;
    }, 2000);
    debouncedWarningNotify();
  } else {
    debouncedWarningNotify();
  }
};

export const infoNotify = (message) => {
  if (!debouncedInfoNotify) {
    toast.info(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      transition: Flip,
      theme: "colored",
    });
    debouncedInfoNotify = debounce(() => {
      debouncedInfoNotify = null;
    }, 2000);
    debouncedInfoNotify();
  } else {
    debouncedInfoNotify();
  }
};
